import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@repo/videa-components/src/index';
import type { Table } from '@tanstack/react-table';
import { format } from 'date-fns';
import { useAtomValue } from 'jotai';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { sanitizeForFilename } from '@/utils/file';

import { endDateAtom, startDateAtom } from '../atoms';
import { exportTableToCsv } from '../helpers/exportTableToCsv';

type InsightsExportButtonProps<TData> = {
  table: Table<TData>;
  name?: string;
  isDisabled?: boolean;
};

export const InsightsExportButton = <TData,>({
  table,
  name,
  isDisabled = false,
}: InsightsExportButtonProps<TData>) => {
  const showPhi = useSelector(
    (state: { login?: { user?: { privacyOn?: boolean } } }) =>
      state.login?.user?.privacyOn ?? false,
  );
  const isPrivacyOn = !showPhi;
  const location = useLocation();
  const selectedDashboard = location.pathname.includes('clinical')
    ? 'clinical'
    : 'hygiene';

  const startDate = useAtomValue(startDateAtom);
  const endDate = useAtomValue(endDateAtom);
  const dateRange = `${format(startDate, 'yyyy-MM-dd')}-to-${format(endDate, 'yyyy-MM-dd')}`;
  const filename = sanitizeForFilename(
    `${name ?? 'insights'}-${selectedDashboard}-${dateRange}`,
  );

  return (
    <Button
      variant="outline"
      onClick={() => exportTableToCsv(table, filename, { isPrivacyOn })}
      disabled={isDisabled}
    >
      <FontAwesomeIcon icon={faDownload} />
      Export
    </Button>
  );
};
